<template>
    <div class="fam">
        <div v-if="famA">{{ famA }}&nbsp;>&nbsp;</div>
        <div v-if="famB">{{ famB }}&nbsp;>&nbsp;</div>
        <div v-if="famC">{{ famC }}&nbsp;>&nbsp;</div>
    </div>
    <div class="content">
        <div class="missing" v-if="info.count == 0">抱歉，您需要的资源正在赶来的路上......</div>
        <div class="resList" v-if="info.count > 0" v-for="res in info.results" :key="res.id">
            <div class="preview">
                <a :href="'/res/' + res.id" target="_blank">
                    <img :src=res.imgurl >
                </a>
            </div>
            <ul>
                <li style="color: #45B5B5; font-size: 12px; line-height: 18px; font-weight: bold;">编&nbsp;&nbsp;号: {{ res.id }}</li>
                <li>名&emsp;称: {{ res.name }}</li>
                <li>尺&emsp;寸: {{ Math.floor(res.sizex / 10) }}×{{ Math.floor(res.sizey / 10) }}×{{ Math.floor(res.sizez / 10) }}cm</li>
                <li>面&emsp;数: {{ (res.faces/10000).toFixed(2) }}w</li>
                <li>渲染器: {{ res.engine }}</li>
            </ul>
        </div>
    </div>
    <Page :info="info" />
</template>

<script>
    import Page from '@/components/Page.vue'
    import axios from 'axios';

    export default {
        components: { Page },
        name: 'resList',        
        data: function() {
            return {
                info: '',
            };
        },

        computed:{
            famA(){
                const famaStr = this.$route.query.familya;
                if (!famaStr || famaStr == '全部'){
                    return '';
                }
                return famaStr;
            },

            famB(){
                const fambStr = this.$route.query.familyb;
                if (!fambStr || fambStr == '全部'){
                    return null;
                }
                return fambStr;
            },

            famC(){
                const famcStr = this.$route.query.familyc;
                if (!famcStr || famcStr == '全部'){
                    return null;
                }
                return famcStr;
            },
        },

        mounted(){
            this.getResData()
        },

        methods: {
            getResData: function(){
                let url = '/api/res'
                const page = Number(this.$route.query.page);
                const familya = this.$route.query.familya === '全部' ? '' : this.$route.query.familya;
                const familyb = this.$route.query.familyb === '全部' ? '' : this.$route.query.familyb;
                const familyc = this.$route.query.familyc === '全部' ? '' : this.$route.query.familyc;
                const search = this.$route.query.search;
                let selectedStyles = [];
                if (this.$route.query.style) {
                    selectedStyles = Array.isArray(this.$route.query.style) 
                    ? this.$route.query.style 
                    : [this.$route.query.style];
    }

                const params = new URLSearchParams();
                if(page){
                    params.append('page', page)
                }
                if(familya){
                    params.append('familya', familya)
                }
                if(familyb){
                    params.append('familyb', familyb)
                }
                if(familyc){
                    params.append('familyc', familyc)
                }
                selectedStyles.forEach(style => {
                    params.append('style', style);
                });
                if(search){
                    params.append('search', search)
                }

                url = url + "?" + params.toString()

                axios
                    .get(url)
                    .then(response => {
                        this.info = response.data;
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
        },

        watch:{
            $route(){
                this.getResData()
                window.scrollTo({ top: 0, });
            },
        }
    };
</script>

<style>

.fam{
    display: flex;
    width: 1280px;
    margin: 6px auto;
}

.fam *{
    color: #45B5B5;
}

.content{
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 22px;
    width: 1280px;
    margin: 0 auto;
    border-top: 2px solid #45B5B5;
    border-bottom: 2px solid #45B5B5;
}

.missing{
    width: 1024px;
    text-align: center;
    line-height: 240px;
    color: rgb(175, 175, 175); 
    margin: 0 auto;
}

.resList{
    height: auto;
    margin: 10px 0;
    width: 164px;
    padding: 0;
}

.preview{
    margin: 0;
    padding: 0;
    width: 160px;
    height: 160px;
    cursor: pointer;
    border: 2px solid transparent;
    display: inline-block;
    border-radius: 7px;
    transition: all 0.4s cubic-bezier(0.5, 0.46, 0.45, 0.94);
}

.preview:hover{
    border: 2px solid #45B5B5;
    border-radius: 7px;
}

.preview img{
    border-radius: 5px;
    user-select: none;
}

.resList ul{
    width: 152px;
    padding: 0 2px;
}


.resList ul li {
    list-style: none;
    color: rgb(175, 175, 175);
    font-size: 11px;
    line-height: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 164px;
    position: relative;
}

</style>